<template>
  <div class="landing-root">
    <!-- <LandingPageLandingHeader/> -->
    <LandingPagePolicies/>
    <!-- <LandingPageLandingFooter/> -->
    <!-- <LandingPageLandingLoader/> -->
  </div>
</template>

<script setup>
useHead({
  title: 'Oxbull | Privacy Policy',
  meta: [
    { name: 'title', content: "Oxbull | Privacy Policy" },
    { name: 'description', content: "Learn about Oxbull.Tech's commitment to your privacy. Our policies ensure the confidentiality and security of your information while engaging with our blockchain services." }
  ],
  htmlAttrs: { lang: "en" }
})
</script>

<style scoped lang="scss">

$_primary-color: #3f4759;
$_secondary-color: #27e9af;
$_tertiary-color: #ececec;

.landing-root {
  font-family: "Rogan";
  font-weight: 400;
  color: $_primary-color;
  font-synthesis: none;
  overflow: hidden;
  text-rendering: optimizeLegibility;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  -webkit-text-size-adjust: 100%;
}

.secondary-text {
  color: $_secondary-color;
}



</style>